import React, {PropTypes} from 'react';
import FormInput from './forminput.react';

// TODO Inject them via props.
// import {onBlur} from '../../onBlur';
// import {onFocus} from '../../onFocus';

export default class TextInput extends FormInput {
  static propTypes = {
    action: PropTypes.func.isRequired,
    disabled: PropTypes.func,
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    inputTitle: PropTypes.string,
    label: PropTypes.string,
    pattern: PropTypes.string,
    value: PropTypes.string,
    required: PropTypes.bool,
    maxCharacters: PropTypes.number,
    url: PropTypes.string,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
  }

  render() {
    const {
      action,
      name,
      title,
      inputTitle,
      pattern,
      required,
      label,
      value = null,
      maxCharacters,
      disabled,
    } = this.props;

    return (
      <div className="form-group">
        {label &&
          <label>{label}</label>
        }
        <input className="form-control"
           name={name}
           title={inputTitle}
           disabled={disabled}
           onChange={action}
           pattern={pattern}
           placeholder={title}
           onBlur={::this.onInputBlur}
           onFocus={::this.onInputFocus}
           type="text"
           required={required}
           value={value}
           maxLength={maxCharacters}
           ref="input"/>
      </div>
    );
  }
}
